var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.request)?_c('simple-text',{attrs:{"content":_vm.request.owner.fullName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }